<template>
  <b-form-group
    :id="id + '-group'"
    :state="!errors.has(id)"
    :label="label"
    :label-for="id"
    :invalid-feedback="errors.first(id)"
    class="form-textarea"
  >
    <textarea
      :id="id"
      ref="textarea"
      v-model="model"
      v-validate="{ rules: validationRules }"
      :name="id"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="{
        'form-textarea__widget': true,
        'form-textarea__widget--disabled': disabled
      }"
      :data-testing="dataTesting"
      data-vv-validate-on="blur"
      rows="4"
      @blur="onBlur"
      @input="onInput"
    />
  </b-form-group>
</template>

<script>
import Vue from 'vue';
import { BFormGroup } from 'bootstrap-vue';

/**
 * Textarea component
 */
export default {
  name: 'FormTextarea',
  components: {
    BFormGroup
  },
  inject: {
    $validator: '$validator'
  },
  props: {
    /**
     * textarea id - it's used also as name attribute and for error handling
     */
    id: {
      type: String,
      required: true
    },
    /**
     * label for the bootstrap form group
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * required attribute
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * placeholder for input field
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * value to fill in data from the api
     */
    value: {
      type: String,
      default: null
    },
    /**
     * custom validation rules if needed
     */
    validation: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Variable for cypress testing
     */
    dataTesting: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      /**
       * @model
       */
      model: ''
    };
  },
  computed: {
    /**
     * Sets the validationRules, according to the type of the input field.
     */
    validationRules() {
      if (this.validation !== null) return this.validation;

      const rules = {
        required: this.required
      };

      return rules;
    }
  },
  watch: {
    value(newVal) {
      if (this.model !== newVal) this.model = newVal;
    }
  },
  mounted() {
    if (this.value) this.model = this.value;
  },
  methods: {
    /**
     * update model and validate field
     * @event onBlur
     * @type {Blur}
     */
    onBlur() {
      this.$validator.validate(this.id);

      this.$emit('onchange', { key: this.id, val: this.model });
    },
    /**
     * Notify parent component
     *
     * @event onInput
     * @type {Input}
     */
    onInput() {
      this.$emit('oninput', this.model);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./FormTextarea";
</style>
